(function ($, window) {
  let $tabMediaFilters = $('.mcl-news-filters');
  if ($tabMediaFilters.length > 0) {

  }
})
(jQuery, window);
